import Vue from 'vue'
import VueRouter from 'vue-router'
import examRoutes from '../views/exam/utils/routes'
import reportRoutes from '../views/report/utils/routes'
import templateConfiguration from '../views/template-configuration/utils/routes'
import equipRoutes from '../views/equip/utils/routes'
Vue.use(VueRouter)
const routes = [...examRoutes, ...reportRoutes, ...templateConfiguration, ...equipRoutes]

const router = new VueRouter({
	routes
})

export default router
